module.exports = __webpack_public_path__ + "static/media/Evelyn-profile-icon.bd0001cc.png";